export default __webpack_public_path__ + "static/media/204370.4c48a534.jpg";